<template>
  <div class="instance-profile-card" :class="[`theme-${theme}`, { 'is-fetching': _get(InstanceInfo, 'fetching'), 'is-no-logo': !isHaveLogo }]">

    <!-- <template v-if="true"> -->
    <template v-if="_get(InstanceInfo, 'fetching')">

      <div class="instance-profile-card__content">
        <div class="content__image-wrap">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
            <filter id="blur">
                <feGaussianBlur stdDeviation="15"></feGaussianBlur>
            </filter>
          </svg>
          <div class="background-mask">
            <div class="full-picture blur" :style="logoFirstBackgroundImage"></div>
          </div>
          <div class="image-circle">
            <i class="fal fa-spinner-third fa-spin"></i>
          </div>
        </div>
        <div class="content__title">
          <p class="content__title__name">
            <span class="loading-dot-blink"><span>.</span><span>.</span><span>.</span></span>
          </p>
        </div>
      </div>
    </template>

    <template v-else>

      <div class="instance-profile-card__content">

        <div class="content__image-wrap">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
            <filter id="blur">
                <feGaussianBlur stdDeviation="7"></feGaussianBlur>
            </filter>
          </svg>
          <div class="background-mask">
            <div class="background-mask__shade" v-if="isHaveLogo && maskShade"></div>
            <div class="full-picture blur" :style="logoFirstBackgroundImage"></div>
          </div>
          <div class="image-circle">
            <div class="image" :style="profileFirstBackgroundImage"></div>
          </div>
        </div>

        <div class="content__title">
          <p class="content__title__name">{{ _get(InstanceInfo, 'data.name') }}</p>
          <p class="ui-element horizontal-divider">
            <span>{{ $t('label.subdomain_example_url', { subdomain: _get(InstanceInfo, 'data.subdomain' ) }) }}</span>
          </p>
        </div>

      </div>
      <!-- end ~ instance-profile-card__content -->
    </template>
  </div>
</template>

<script>
import InstanceProfileCard from './instance-profile-card';

export default {
  name: 'instance-section-profile-card',
  mixins: [InstanceProfileCard],
};
</script>



// WEBPACK FOOTER //
// src/components/ui/card/instance-section-profile-card.vue